export const isBusinessOrganization = (organization) => {
    if(organization === undefined || organization === null) return false

    return organization.personal === false;
};